export const currencyFormatter = (value: number | null | undefined, currencyIsoCode: string = "EUR") => {
	const numValue = value ?? 0
	return numValue.toLocaleString("es-ES", {
		style: "currency",
		currency: currencyIsoCode || "EUR"
	})
}
